export class TicketRequest {
    public Drawings: number;
    public SelectedNumbers: number[];
    public Stake: number;
    public BingoGameId: number;
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/domain/ticket-request.ts